export const environment = {
  production: true,
  deployment: 'prod',
  STATEMENT_MESSAGING: {
    BASE_URL: 'https://mu4-statement-messaging-internal.ecs.retailinvest1p.c1.vanguard.com',
    MESSAGE: '/messages',
    ADD_UPDATE_DELETE_MESSAGE: '/messages',
    LOGIN_ERROR: '/login-error',
    LOGGER: '/client-log',
    JWT_EXCHANGE_TOKEN: '/jwt-exchange',
    TEXT_MESSAGE_BY_ID: '/messages/view-message',
    FUND_ID: '/funds'
  },
  oidc: {
    clientId: 'MU3_5efbc83c-63ec-4cdb-810f-77dc407d36ce',
    issuer: 'https://vanguard.okta.com/oauth2/aus1rcsxtvpzM7axB358',
    redirectUri: "https://statements-messaging-i.web.vanguard.com/login/callback",
    scopes: ['openid', 'profile', 'email'],
    testing: {
      disableHttpsCheck: false
    },
  },
};
